import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { CircularProgress, styled } from '@mui/material';
import { useAuthContext } from 'context/AuthContext/AuthContext';
import { API_PATH } from 'common/constants/services';
import useLazyQuery from 'hook/useLazyQuery';
import Header from 'components/Header';
import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
  flexDirection: 'column',
  flex: 1,
  boxSizing: 'border-box',
});
const Container = styled('div')`
  display: flex;
  flex: 1;
  flex-direction: row;
`;

const MainStyle = styled('div')(({ theme }) => ({
  // overflow: 'auto',f
  flex: 1,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingBottom: 0,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export function Layouts() {
  const navigate = useNavigate();
  const { token, isLoading } = useAuthContext();
  const [open, setOpen] = useState(true);
  const [isValidToken, setValidToken] = useState(false);
  const me = useLazyQuery<any>(API_PATH.ME, {
    onSuccess: () => {
      setValidToken(true);
    },
    onError: () => {
      setValidToken(false);
      navigate('logout');
    },
  });

  useEffect(() => {
    if (token && !isLoading && !isValidToken) {
      // me.refetch();
    }
  }, [token, me, isLoading, isValidToken]);

  if (!token) {
    if (!isLoading) {
      return <Navigate to='/auth/login' />;
    }

    return (
      <RootStyle>
        <CircularProgress />
      </RootStyle>
    );
  }

  return (
    <RootStyle>
      <Navbar onOpenSidebar={() => setOpen(true)} />
      <Container>
        <Sidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
        <MainStyle>
          <Outlet />
        </MainStyle>
      </Container>
    </RootStyle>
  );
}
